/* eslint-disable no-nested-ternary */
import React, { useMemo } from 'react'
import { UserProfileModel, WSChatMessage } from 'mvppoker-portal-common/api'
import { getCardBackUrl } from '../../../logic/Decks'
import './LobbyChatListItem.scss'

export interface LobbyChatListItemProps
{
    userId: string,
    userAvatar: string,
    senderProfile?: UserProfileModel,
	chatMessage: WSChatMessage
}
const userColor = '#008000'
const systemColor = '#000000'

export const LobbyChatListItem: React.FC<LobbyChatListItemProps> = ({ userId, userAvatar, senderProfile, chatMessage }) =>
{
    const systemAvatar = useMemo(() =>
    {
        return getCardBackUrl(0)
    },[])

    const { fromId, message, timestamp, cards } = chatMessage

    const isSystemMessage = fromId === '0'

    const isUserMessage = fromId === userId
    const marginLeft = isSystemMessage ? '10px' : isUserMessage ? '20px' : '0px'
    const marginRight = isSystemMessage ? '10px' : isUserMessage ? '5px' : '20px'
    const avatar = isSystemMessage ? systemAvatar : isUserMessage ? userAvatar: senderProfile?.info.avatar ?? ''
    const name = isSystemMessage ? 'Dealer' : isUserMessage ? 'You' : senderProfile?.info.name ?? ''
    const messageLabelClass = isUserMessage ? 'user' : ''

    const getProfileColor = (id: string) : string => {
        // TODO: generate hash
        return '#000080'
    }

    const backgroundColour = isUserMessage ? userColor : isSystemMessage ? systemColor : getProfileColor(fromId)

	return (
		<div className='lobby-chat-list-item mvp-list-item' style={{ backgroundColor: backgroundColour, marginLeft, marginRight  }}>
            <img className='avatar' src={avatar} alt='avatar'/>
            <p id='date-label'>{`${new Date(timestamp).toLocaleTimeString()}`}</p>
            <p id='name-label'>{name}</p>
            <p id='message-label' className={messageLabelClass}>{message}</p>
		</div>
	)
}
